import {Container} from "inversify";
import {Module} from "@/modules";
import {DependencyResolver} from "@/di/dependency-resolver";
import {EventEmitter} from "@/modules/base/events";
import {AppLoadedEvent} from "@/modules/base/events/AppLoadedEvent";

export class Application extends Container {
  public modules: Module[] = [];

  constructor() {
    super({defaultScope: 'Singleton'});

    this.bind<DependencyResolver>(DependencyResolver).to(DependencyResolver).inSingletonScope();
    this.bind<Application>(Application).toConstantValue(this);
  }

  public async run() {
    this
      .modules
      .forEach(module => module.setApplication(this).init());

    for (const module of this.modules) {
      await module.boot();
    }

    await this.get(EventEmitter).emitAsync(new AppLoadedEvent(this));
  }

  addModules(modules: Module[]) {
    this.modules = this.get(DependencyResolver).resolve([...this.modules, ...modules]);
  }
}

const container = new Application();

export {container as container};
export {container as app};